import React from 'react';
import ReadMore from '../components/ReadMore';
import { FaWhatsapp } from "react-icons/fa6";
import { MdOutlineSlowMotionVideo, MdAnimation, MdOutlineMonitor } from "react-icons/md";

const VideoPage = () => {

    const videoUrls = [
        "https://youtube.com/shorts/8i8oAR5Ayq0",
        "https://youtube.com/shorts/RvJtVonkv4M",
        "https://www.facebook.com/100004911302117/videos/pcb.2583348961838789/1940415809689126",
        "https://www.facebook.com/100004911302117/videos/pcb.2583348961838789/2228487677502322",
        "https://www.facebook.com/100004911302117/videos/pcb.2583348961838789/871879334714320",
        "https://www.facebook.com/100004911302117/videos/pcb.2583348961838789/689023693387282",
        "https://www.facebook.com/100004911302117/videos/pcb.2583348961838789/1685158668640456",
        "https://www.facebook.com/100004911302117/videos/pcb.2583348961838789/735001631574365",
        "https://www.facebook.com/100004911302117/videos/pcb.2583348961838789/193055173898453",
        "https://www.facebook.com/100004911302117/videos/pcb.2583348961838789/1050443589599478",
        "https://www.facebook.com/100004911302117/videos/pcb.2583348961838789/349791844710639",
        "https://www.facebook.com/100004911302117/videos/pcb.2583348961838789/1112261986461123",
        "https://www.facebook.com/100004911302117/videos/pcb.2583348961838789/1480529535837051"
    ];

    return (
        <div className="bg-black text-mainColor font-sans">
            {/* Hero Section */}
            <div className="pt-56 md:pt-64 pb-28 relative flex flex-col items-center justify-center brandingBg overflow-hidden" dir="rtl">
                <div className="absolute inset-0 bg-black/60 backdrop-blur-[2px]"></div>
                
                <div className="relative z-10 text-center max-w-[1000px] px-4">
                    <MdOutlineSlowMotionVideo className="text-6xl md:text-8xl text-orange-500 mx-auto mb-6 opacity-90 drop-shadow-[0_0_15px_rgba(234,120,8,0.5)]" />
                    <h1 data-aos="fade-down" className="font-bold text-4xl md:text-6xl lg:text-7xl gold-text mb-6 drop-shadow-2xl">
                        עריכת וידאו ופרסום ויזואלי
                    </h1>
                    <h2 data-aos="fade-up" className="font-medium text-xl md:text-3xl text-gray-200 mb-10 max-w-[800px] mx-auto leading-relaxed">
                        אנחנו עובדים עם התוכנות הכי מתקדמות בשוק כדי לספק לכם וידאו מקצועי ומותאם אישית לעסק שלכם.
                    </h2>
                    
                    <button
                        data-aos="zoom-in" data-aos-delay="200"
                        className='group relative overflow-hidden bg-gradient-to-tr from-orange-600 via-orange-500 to-orange-400 text-black font-bold text-lg md:text-2xl rounded-full px-8 py-4 shadow-[0_0_30px_rgba(234,120,8,0.3)] hover:shadow-[0_0_40px_rgba(234,120,8,0.5)] transition-all duration-300 hover:scale-105'
                        onClick={() => {
                            const phoneNumber = '972522849593';
                            const message = encodeURIComponent('היי, הגעתי מהאתר. אשמח לפרטים בנוגע לפרסום ועיצוב וידאו לעסק שלי');
                            const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
                            window.open(whatsappUrl, '_blank');
                        }}
                    >
                        <span className="flex items-center gap-3 relative z-10">
                            <span className="pr-2">לשיחת ייעוץ בוואטסאפ</span> 
                            <FaWhatsapp size={32} className="group-hover:rotate-12 transition-transform duration-300" />
                        </span>
                    </button>
                </div>
            </div>

            {/* Services Section */}
            <div dir='rtl' className='py-24 px-4 specialBg relative'>
                <div className="max-w-[1200px] mx-auto">
                    <h2 data-aos="fade-down" className="font-bold text-3xl md:text-5xl text-center gold-text mb-16">
                        מה אנחנו מציעים?
                    </h2>
                    
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <div data-aos="fade-up" data-aos-delay="100" className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-3xl text-center hover:bg-white/10 transition-all duration-300 hover:-translate-y-2">
                            <div className="w-20 h-20 bg-orange-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
                                <MdOutlineSlowMotionVideo className="text-4xl text-orange-500" />
                            </div>
                            <h3 className="text-2xl font-bold text-white mb-4">עריכת וידאו מקצועית</h3>
                            <p className="text-gray-400 text-lg">סרטוני תדמית, פרסומות וסרטוני מוצר ערוכים ברמה הגבוהה ביותר.</p>
                        </div>

                        <div data-aos="fade-up" data-aos-delay="200" className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-3xl text-center hover:bg-white/10 transition-all duration-300 hover:-translate-y-2">
                            <div className="w-20 h-20 bg-orange-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
                                <MdAnimation className="text-4xl text-orange-500" />
                            </div>
                            <h3 className="text-2xl font-bold text-white mb-4">פוסטים מונפשים</h3>
                            <p className="text-gray-400 text-lg">הנפשת אלמנטים ועיצוב דינמי שתופס את העין ברשתות החברתיות.</p>
                        </div>

                        <div data-aos="fade-up" data-aos-delay="300" className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-3xl text-center hover:bg-white/10 transition-all duration-300 hover:-translate-y-2">
                            <div className="w-20 h-20 bg-orange-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
                                <MdOutlineMonitor className="text-4xl text-orange-500" />
                            </div>
                            <h3 className="text-2xl font-bold text-white mb-4">מסכי פרסום ושלטים</h3>
                            <p className="text-gray-400 text-lg">התאמת פורמטים והפקת תוכן וידאו למסכי ענק ושלטי חוצות אלקטרוניים.</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Gallery Section */}
            <div dir='rtl' className='py-24 px-4 bg-black/90'>
                <h2 data-aos="fade-down" className="font-bold text-3xl md:text-5xl text-center gold-text mb-4">
                    עבודות להתרשמות
                </h2>
                <p data-aos="fade-in" className="text-center text-gray-400 text-xl mb-16 max-w-[600px] mx-auto">
                    הצצה לחלק מפרויקטי הוידאו שלנו – פרסומות, פוסטים שיווקיים וסרטוני אווירה
                </p>

                <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {videoUrls.map((url, index) => {
                        const isYouTube = url.includes('youtube.com') || url.includes('youtu.be');
                        const videoId = isYouTube ? url.split('/').pop().split('?')[0] : '';
                        
                        return (
                        <div key={index} data-aos="zoom-in" data-aos-delay={(index % 3) * 100} className="w-full aspect-[4/5] md:aspect-square relative group rounded-2xl overflow-hidden shadow-2xl border border-white/10">
                            <div className="absolute inset-0 bg-gradient-to-t from-orange-600/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none z-10"></div>
                            <iframe
                                src={isYouTube 
                                    ? `https://www.youtube.com/embed/${videoId}` 
                                    : `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&show_text=0`}
                                width="100%"
                                height="100%"
                                title={`Video ${index}`}
                                className="absolute inset-0 w-full h-full object-cover bg-black"
                                style={{ border: 'none', overflow: 'hidden' }}
                                scrolling="no"
                                frameBorder="0"
                                allowFullScreen={true}
                                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share">
                            </iframe>
                        </div>
                    )})}
                </div>
            </div>

            <ReadMore links={[
                { text: 'דף הבית', link: '/' },
                { text: 'עיצוב גרפי מיתוג ופרסום', link: '/Branding' },
                { text: 'דפוס דיגיטלי', link: '/Print' },
                { text: 'סרטוני בינה מלאכותית לעסקים', link: '/AIVideo' },
                { text: 'חבילות מיתוג', link: '/Branding#branding-packages' },
                { text: 'יצירת קשר', link: '/Contact' },
            ]} />
            
        </div>
    );
}

export default VideoPage;